// ── Enum des types de laboratoire (miroir du back) ──────────
export enum LaboratoryType {
  LABORATOIRE_PRELEVEUR = 'LABORATOIRE_PRELEVEUR',
  LABORATOIRE_EXECUTANT = 'LABORATOIRE_EXECUTANT',
}

export const LABORATORY_TYPE_LABELS: Record<LaboratoryType, string> = {
  [LaboratoryType.LABORATOIRE_PRELEVEUR]: 'Laboratoire préleveur',
  [LaboratoryType.LABORATOIRE_EXECUTANT]: 'Laboratoire exécutant',
};

// ── Interface laboratoire ───────────────────────────────────
export interface Laboratory {
  _id: string;
  name: string;
  type: LaboratoryType;
  address: string;
  logoPath: string | null;
  createdAt: string;
  updatedAt: string;
}
